import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=9f643f34&scoped=true"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=9f643f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f643f34",
  null
  
)

export default component.exports